import {createElement, removeElement} from './utils/domManager';

/**
 * Overlay container module
 * It serves to disable iframe interactivity
 * @returns {Object}
 */
const overlay = (options) => {
    const overlayDomElement = createElement('div', { className: 'overlay'});
    const textElement = createElement('span', { className: 'overlay-text'});

    setTextContent();

    /**
     * Sets inner text in text element
     */
    function setTextContent() {
        textElement.innerHTML = options.interactivity.text;
    }

    function setInvisibility() {
        overlayDomElement.style.backgroundColor = '';
        overlayDomElement.style.pointerEvents = 'none';
        textElement.style.opacity = 0;
    }

    function onContainerMouseEnter(event) {
        // makes overlay dark if not on full screen
        if (document.fullscreenElement !== event.currentTarget) {
            overlayDomElement.style.backgroundColor = 'rgba(0, 0, 0, .35)';
            textElement.style.opacity = 1;
        }
    }

    function onContainerMouseLeave(event) {
        // makes overlay invisible and interactive if not on full screen
        // (interactive overlay means that iframe is non-interactive)
        if (document.fullscreenElement !== event.currentTarget) {
            overlayDomElement.style.backgroundColor = '';
            overlayDomElement.style.pointerEvents = 'auto';
            textElement.style.opacity = 0;
        }
    }

    function onOverlayDomClick() {
        // makes overlay invisible and non-interactive on click
        // (non-interactive overlay means that iframe is interactive)
        setInvisibility();
    }

    function onFullScrenChange() {
        // makes overlay invisible and non-interactive when full screen is triggered
        // (non-interactive overlay means that iframe is interactive)
        if (document.fullscreenElement) {
            setInvisibility();
        }
    }

    function addListeners(containerElement) {
        containerElement.addEventListener('mouseenter', onContainerMouseEnter);
        containerElement.addEventListener('mouseleave', onContainerMouseLeave);
        overlayDomElement.addEventListener('click', onOverlayDomClick);
        document.addEventListener('fullscreenchange', onFullScrenChange);
    }

    function removeListeners(containerElement) {
        containerElement.removeEventListener('mouseenter', onContainerMouseEnter);
        containerElement.removeEventListener('mouseleave', onContainerMouseLeave);
        overlayDomElement.removeEventListener('click', onOverlayDomClick);
        document.removeEventListener('fullscreenchange', onFullScrenChange);
    }

    /**
     * Appends overlay (and text) element in DOM and creates listeners
     */
    function render(containerElement) {
        containerElement.style.position = 'relative';
        containerElement.appendChild(overlayDomElement);
        overlayDomElement.appendChild(textElement);
        addListeners(containerElement);
    }

    function remove(containerElement) {
        removeElement(containerElement, overlayDomElement);
        removeListeners(containerElement);
    }

    return {
        render,
        remove
    };
};

export default overlay;
